import { dispatch } from "hf-rt";

const initialState = {
  errorPage: false
};

export default {
  name: "errorPage",
  actions: {
    showErrorPage: function(bool) {
      dispatch({ type: "SHOW_ERROR_PAGE", bool });
    }
  },
  reducers: function(state = initialState, action) {
    switch (action.type) {
      case "SHOW_ERROR_PAGE":
        return {
          ...state,
          errorPage: action.bool
        };
      default:
        return state;
    }
  }
};
